<template>
  <div>
    <v-dialog
      max-width="600px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Compensations
          <v-spacer></v-spacer>
          <v-text-field
            dense
            hide-details
            v-model="search"
            append-icon="mdi-magnify"
            label="Search compensation"
            class="mr-2"
          ></v-text-field>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-data-table
            dense
            :headers="compensations_headers"
            :items="compensations"
            :items-per-page="-1"
            :search="search"
            hide-default-footer
          >
            <template v-slot:[`item.Date_of_Update`]="{ item }">
              {{ item.Date_of_Update | dateFilter }}
            </template>
            <template v-slot:[`item.Actions`]="{ item }">
              <v-btn icon small
                @click.prevent="getCompensationDetailsById(item.Compensation_Amount_ID)"
                color="primary"
              >
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn small outlined color="primary" @click="showCompensationTypeManager = true"> Compensation Types </v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="addNewCompensation">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteCompensationDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title>Remove Compensation</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          Are you sure?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn small color="primary" @click="deleteCompensationDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-4 white--text" @click="removeCompensation">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CompensationEditor
      v-model="showCompensationEditor"
      :addMode="addMode"
      :currentCompensation="selectedCompensation"
    ></CompensationEditor>
    <CompensationTypeManager
      v-model="showCompensationTypeManager"
    ></CompensationTypeManager>
  </div>
</template>
<script>

export default {
  name: 'CompensationsManager',
  props: {
    value: {
      required: false
    }
  },
  components: {
    CompensationEditor: () => import('@/components/payroll/CompensationEditor.vue'),
    CompensationTypeManager: () => import('@/components/payroll/CompensationTypeManager.vue')
  },
  data () {
    return {
      addMode: false,
      showEditor: false,
      selectedCompensation: {},
      search: '',
      compensations: null,
      deleteCompensationDialog: false,
      showTypeManager: false,
      compensations_headers: [
        {
          text: 'Name of Compensation',
          value: 'Compensation_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Date of Update',
          value: 'Date_of_Update',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Amount',
          value: 'Compensation_Amount',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Currency',
          value: 'Compensation_Currency',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '5%',
          sortable: false
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.getCompensations()
        this.$emit('input', value)
      }
    },
    showCompensationEditor: {
      get () {
        return this.showEditor
      },
      set (value) {
        this.getCompensations()
        this.showEditor = value
      }
    },
    showCompensationTypeManager: {
      get () {
        return this.showTypeManager
      },
      set (val) {
        if (!val) {
          this.getCompensations()
        }
        this.showTypeManager = val
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
    this.getCompensations()
  },
  methods: {
    getCompensations () {
      this.axios.get('/api/payroll/compensations', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.compensations = response.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getCompensationDetailsById (id) {
      this.axios.get(`/api/payroll/compensation/${id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.selectedCompensation = res.data[0]
        this.selectedCompensation.Date_of_Update = new Date(this.selectedCompensation.Date_of_Update).toISOString().substr(0, 10)
        this.addMode = false
        this.showCompensationEditor = true
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    addNewCompensation () {
      this.selectedCompensation.Compensation_Amount_ID = null
      this.selectedCompensation.Compensation_Type_ID = null
      this.selectedCompensation.Compensation_Name = ''
      this.selectedCompensation.Date_of_Update = new Date().toISOString().substr(0, 10)
      this.selectedCompensation.Compensation_Amount = null
      this.selectedCompensation.Compensation_Currency = ''
      this.addMode = true
      this.showCompensationEditor = true
    },
    deleteCompensation (id) {
      this.selectedCompensation.Compensation_Amount_ID = id
      this.deleteCompensationDialog = true
    },
    removeCompensation () {
      this.axios.delete(`/api/payroll/compensation/${this.selectedCompensation.Compensation_Amount_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Compensation succesefully deleted' })
        this.getCompensations()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  },
  filters: {
    dateFilter (val) {
      return val ? new Date(val).toISOString().substr(0, 10) : ''
    }
  }
}
</script>
